var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65116 15.7649H3.68605C3.64907 15.7649 3.61349 15.7495 3.58767 15.7237C3.56116 15.6972 3.54651 15.6623 3.54651 15.6254V14.613C3.54651 14.034 3.96023 13.5233 4.59791 13.0893C5.73651 12.3121 7.57907 11.8223 9.65116 11.8223C9.94 11.8223 10.1744 11.5879 10.1744 11.2991C10.1744 11.0109 9.94 10.7758 9.65116 10.7758C7.33349 10.7758 5.28163 11.3556 4.00767 12.2242C3.03581 12.887 2.5 13.7291 2.5 14.613V15.6254C2.5 15.9393 2.62488 16.2414 2.84744 16.464C3.07 16.6858 3.3714 16.8114 3.68605 16.8114H9.65116C9.94 16.8107 10.1744 16.5763 10.1744 16.2874C10.1744 15.9993 9.94 15.7642 9.65116 15.7649Z",
    fill: "#65748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65117 2.5C7.53303 2.5 5.81396 4.21907 5.81396 6.33721C5.81396 8.45535 7.53303 10.1744 9.65117 10.1744C11.7693 10.1744 13.4884 8.45535 13.4884 6.33721C13.4884 4.21907 11.7693 2.5 9.65117 2.5ZM9.65117 3.54651C11.1916 3.54651 12.4419 4.79674 12.4419 6.33721C12.4419 7.87768 11.1916 9.12791 9.65117 9.12791C8.11071 9.12791 6.86048 7.87768 6.86048 6.33721C6.86048 4.79674 8.11071 3.54651 9.65117 3.54651Z",
    fill: "#65748B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8372 11.3521C12.4655 11.3521 11.3521 12.4656 11.3521 13.8372C11.3521 15.2088 12.4655 16.323 13.8372 16.323C15.2088 16.323 16.323 15.2088 16.323 13.8372C16.323 12.4656 15.2088 11.3521 13.8372 11.3521ZM13.8372 12.3986C14.6311 12.3986 15.2765 13.0433 15.2765 13.8372C15.2765 14.6312 14.6311 15.2765 13.8372 15.2765C13.0432 15.2765 12.3979 14.6312 12.3979 13.8372C12.3979 13.0433 13.0432 12.3986 13.8372 12.3986Z",
    fill: "#65748B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3605 11.8746V10.6977C14.3605 10.4088 14.1261 10.1744 13.8372 10.1744C13.5484 10.1744 13.314 10.4088 13.314 10.6977V11.8753C13.314 12.1635 13.5484 12.3986 13.8372 12.3986C14.1261 12.3979 14.3605 12.1635 14.3605 11.8746Z",
    fill: "#65748B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5944 12.82L16.4268 11.987C16.6312 11.7833 16.6312 11.4512 16.4268 11.2474C16.223 11.043 15.891 11.043 15.6872 11.2474L14.8542 12.0798C14.6505 12.2842 14.6505 12.6156 14.8542 12.82C15.0586 13.0237 15.39 13.0237 15.5944 12.82Z",
    fill: "#65748B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7989 14.3605H16.9766C17.2654 14.3605 17.4999 14.1261 17.4999 13.8372C17.4999 13.5484 17.2654 13.314 16.9766 13.314H15.7989C15.5108 13.314 15.2764 13.5484 15.2764 13.8372C15.2757 14.1261 15.5108 14.3605 15.7989 14.3605Z",
    fill: "#65748B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8545 15.5947L15.6875 16.427C15.8912 16.6314 16.2233 16.6314 16.427 16.427C16.6314 16.2233 16.6314 15.8912 16.427 15.6874L15.5947 14.8544C15.3903 14.6507 15.0589 14.6507 14.8545 14.8544C14.6507 15.0588 14.6507 15.3902 14.8545 15.5947Z",
    fill: "#65748B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.314 15.7991V16.9767C13.314 17.2656 13.5484 17.5 13.8372 17.5C14.1261 17.5 14.3605 17.2656 14.3605 16.9767V15.7991C14.3605 15.5109 14.1261 15.2765 13.8372 15.2758C13.5484 15.2758 13.314 15.5109 13.314 15.7991Z",
    fill: "#65748B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0796 14.8544L11.2473 15.6874C11.0429 15.8912 11.0429 16.2233 11.2473 16.427C11.451 16.6314 11.7831 16.6314 11.9868 16.427L12.8199 15.5947C13.0236 15.3902 13.0236 15.0588 12.8199 14.8544C12.6154 14.6507 12.2841 14.6507 12.0796 14.8544Z",
    fill: "#65748B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8748 13.314H10.6978C10.409 13.314 10.1746 13.5484 10.1746 13.8372C10.1746 14.1261 10.409 14.3605 10.6978 14.3605H11.8748C12.1636 14.3605 12.3987 14.1261 12.398 13.8372C12.398 13.5484 12.1636 13.314 11.8748 13.314Z",
    fill: "#65748B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8199 12.0798L11.9868 11.2474C11.7831 11.043 11.451 11.043 11.2473 11.2474C11.0429 11.4512 11.0429 11.7832 11.2473 11.987L12.0796 12.82C12.2841 13.0237 12.6154 13.0237 12.8199 12.82C13.0236 12.6156 13.0236 12.2842 12.8199 12.0798Z",
    fill: "#65748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDesignation);
export default __webpack_public_path__ + "static/media/users_designation.4d12cb253d0d1a3d8de48903dab33c31.svg";
export { ForwardRef as ReactComponent };